export enum PreferenceType {
	CODES_CPV = 'CODES_CPV',
	DIFFUSEURS = 'DIFFUSEURS',
	LOGO = 'LOGO',
	FACTURATION = 'FACTURATION',
	ANNONCEUR = 'ANNONCEUR',
	ACHETEUR = 'ACHETEUR'
}
